<template>
  <p
      class="text-primary cursor-pointer font-weight-600 margin-a-0"
      @click="openTripModificationStartDialog"
    >
      Edit Trip
</p>
</template>

<script lang="ts" setup>
import { EventBus } from '@/utils/eventBus';
import tripModificationService from '@/services/tripModification';
import tripModification from '@/store/modules/tripModification';

const props = defineProps<{
  managedId: string
}>()

const openTripModificationStartDialog = async (): Promise<void> => {
  try {
    const res = await tripModificationService.hasDraft(props.managedId)
    tripModification.setIsDraftInProgress(res.data)
  } catch (error) {
    console.error(error)
  }
  EventBus.$emit('open-trip-modification-dialog')
}
</script>
